import React from 'react';
import { Dialog, Grid, IconButton } from 'src/components';
import DialogContent from 'src/components/DialogContent';
import DialogTitle from 'src/components/DialogTitle';
import { translate } from 'src/i18n/tHelper';
import { useAppDispatch, useAppSelector } from 'src/store';
import { MesajSlice } from 'src/store/Slices/Mesaj/MesajSlice';
import MesajListe from './MesajListe';
import VwGnlMesajDTO from 'src/models/Mesaj/VwGnlMesajDTO';
import { Box, Typography } from '@mui/material';

interface IMesajDetayProps { };

const translatePath = "parts|mesaj";
/**
 * Hasta müracaat bazlı açılan kaydın detay bilgilerinin okunduğu genel component
 * @param props 
 * @returns 
*/
const MesajDetay = (props: IMesajDetayProps): JSX.Element => {
    const state = useAppSelector(s => s.mesaj);
    const userInfo = useAppSelector(s => s.userLogin.userInfo);
    const dispatch = useAppDispatch();

    /**
     * Hasta müracaat bazlı yeni mesaj eklenebilmesi için kullanılan fonksiyon
     * @param event 
    */
    const addHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        dispatch(MesajSlice.actions.setActiveRow({ ...new VwGnlMesajDTO(), ekleyenKullanici: userInfo.id }));
        dispatch(MesajSlice.actions.setEditMode(true));
    };
    /**
     * Detay bilgilerinin penceresini kapatmak için kullanılan fonksiyon
     * @param event 
    */
    const closeHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        dispatch(MesajSlice.actions.setOpen(false));
    };
    return (
        <Dialog fullWidth open={state.open} maxWidth="lg">
            <DialogTitle>
                <Typography variant="h5">{translate(translatePath, "Mesajlar Penceresi")}</Typography>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{
                        zIndex: 999999999999,
                        display: "block",
                        textAlign: "center",
                        position: "fixed",
                        top: "0px",
                        right: "0px"
                    }}
                >
                    {!state.editMode && <IconButton customType="add" toolTip={translate(translatePath, "Mesaj Ekle")} onClick={addHandler} />}
                    <IconButton customType="close" onClick={closeHandler} />
                </Box>
            </DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item>
                        <MesajListe />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default MesajDetay;